import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { proposerCardType } from "../../lib/proposerAPI";
import ProfileIcon from "../common/profileIcon";
import {
  Box,
  CardActionArea,
  Skeleton,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import Rating from "@mui/material/Rating";
import styles from "../../styles/proposer/proposerCard.module.css";
import { toShortNumber } from "../../lib/util";
import LinearWithValueLabel from "../common/LinearProgress";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import StorageIcon from "@mui/icons-material/Storage";

export const ProposerCard: React.FC<proposerCardType> = (props) => {
  const { user_id, user_name, quick_stats_data } = props;

  return (
    <Paper elevation={3} className={styles.cardPaper}>
      <CardActionArea
        component={Link}
        to={"/proposer/" + user_id}
        state={{
          user_id: user_id,
          user_name: user_name,
          quick_stats_data: quick_stats_data,
        }}
      >
        <Card className={styles.proposerCard}>
          <ProfileIcon
            userName={user_name === null ? "Unknown" : user_name.trim()}
            height="60px"
            width="60px"
          />
          <Typography gutterBottom variant="h6" component="div">
            {user_name}
          </Typography>

          <Box className={styles.ratingBox}>
            <Rating
              name="size-small"
              defaultValue={
                quick_stats_data.average_rating
                  ? quick_stats_data.average_rating
                  : 0
              }
              readOnly
              precision={0.1}
            />
            <Box sx={{ ml: 1 }}>{`${
              quick_stats_data.average_rating
                ? quick_stats_data.average_rating.toFixed(1)
                : 0
            } `}</Box>
          </Box>

          <CardContent sx={{ backgroundColor: "white", width: "100%", mt: 3 }}>
            <Stack direction="row" className={styles.challengeStack}>
              <Grid container direction="column" alignItems="center">
                <RequestPageOutlinedIcon />
                <Typography color="textPrimary" variant="body2">
                  ${toShortNumber(quick_stats_data.amount_requested)}
                </Typography>
                <Typography variant="caption" color="textPrimary">
                  Requested
                </Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <PublishedWithChangesOutlinedIcon />
                <Typography variant="body2">
                  ${toShortNumber(quick_stats_data.funded_amount)}
                </Typography>
                <Typography variant="caption">Funded</Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <DocumentScannerIcon />
                <Typography variant="body2">
                  {quick_stats_data.number_of_proposals}
                </Typography>
                <Typography variant="caption">Proposals</Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <StorageIcon />
                <Typography variant="body2">
                  {quick_stats_data.funded_proposals}
                </Typography>
                <Typography variant="caption">Projects</Typography>
              </Grid>
            </Stack>

            <Typography variant="body1" color="text.primary" sx={{ pt: 1 }}>
              {"Total Result Votes: " +
                toShortNumber(quick_stats_data.total_result_votes, "comma")}
            </Typography>

            <Box className={styles.ratingBox}>
              <Typography variant="body2" color="green" sx={{ mr: 1 }}>
                {"Total Up Votes: " +
                  toShortNumber(quick_stats_data.total_up_votes, "comma") +
                  " "}
              </Typography>
              |
              <Typography variant="body2" color="#ba000d" textAlign="right">
                {` Total Down Votes:  ${toShortNumber(
                  quick_stats_data.total_down_votes,
                  "comma"
                )}`}
              </Typography>
            </Box>

            <LinearWithValueLabel
              value={
                (quick_stats_data.total_up_votes /
                  (quick_stats_data.total_up_votes +
                    quick_stats_data.total_down_votes)) *
                100
              }
              color1="green"
              color2="#ba000d"
            />

            <Grid className={styles.statProgressBox}>
              <Typography
                variant="body2"
                color="text.primiary"
                className={styles.fixedFontSize}
              >
                {"Conversion Percentage"}
              </Typography>
              <LinearWithValueLabel
                value={quick_stats_data.conversion_percentage * 100}
                color1="green"
                color2="#80cbc4"
              />
            </Grid>

            <Grid className={styles.statProgressBox}>
              <Typography
                variant="body2"
                color="text.primiary"
                className={styles.fixedFontSize}
              >
                {"Funding Percentage"}
              </Typography>
              <LinearWithValueLabel
                value={quick_stats_data.funding_percentage * 100}
                color1="green"
                color2="#80cbc4"
              />
            </Grid>
          </CardContent>
        </Card>
      </CardActionArea>
    </Paper>
  );
};

export const ProposerCardLoading = () => {
  return (
    <Card className={styles.proposerCardLoading}>
      <Skeleton variant="circular" className={styles.skeletonCircular} />
      <Skeleton variant="rectangular" className={styles.skeletonName} />
      <Skeleton variant="rectangular" className={styles.skeletonRating} />
      <Skeleton variant="text" className={styles.fullWidthtextProposer} />
      <Skeleton variant="text" className={styles.fullWidthtextProposer} />
      <CardContent>
        <Skeleton variant="text" className={styles.fullWidthtextProposer} />
        <Skeleton variant="text" className={styles.fullWidthtextProposer} />
        <Skeleton variant="text" className={styles.fullWidthtextProposer} />
      </CardContent>
    </Card>
  );
};
